import { type ReactElement } from 'react'

// 「ヒアリングメモ → 構造化 → 診断」という価値提案を一目で伝えるための図解。
export function OnboardingDiagram (): ReactElement {
  return (
    <svg viewBox='0 0 480 170' className='w-full h-auto' role='img' aria-label='ヒアリングメモを構造化し、仕様の穴を赤ペンで指摘する流れ'>
      <defs>
        <marker id='onboarding-arrow' viewBox='0 0 10 10' refX='8' refY='5' markerWidth='6' markerHeight='6' orient='auto-start-reverse'>
          <path d='M0 0 L10 5 L0 10 z' fill='var(--bp-ink3)' />
        </marker>
      </defs>

      <rect x='12' y='51' width='108' height='68' rx='6' fill='var(--bp-surface2)' stroke='var(--bp-border)' strokeWidth='1.5' />
      <text x='66' y='76' textAnchor='middle' fontSize='11' fill='var(--bp-ink2)'>ヒアリング</text>
      <text x='66' y='91' textAnchor='middle' fontSize='11' fill='var(--bp-ink2)'>メモ</text>
      <line x1='26' y1='100' x2='106' y2='100' stroke='var(--bp-border-s)' strokeWidth='2' />
      <line x1='26' y1='107' x2='86' y2='107' stroke='var(--bp-border-s)' strokeWidth='2' />

      <path d='M124 85 H156' stroke='var(--bp-ink3)' strokeWidth='1.5' markerEnd='url(#onboarding-arrow)' />

      <rect x='160' y='30' width='160' height='110' rx='6' fill='var(--bp-accent-pale)' stroke='var(--bp-accent)' strokeWidth='1.5' />
      <text x='240' y='23' textAnchor='middle' fontSize='11' fontWeight='600' fill='var(--bp-accent)'>構造化</text>
      <rect x='172' y='42' width='64' height='38' rx='3' fill='var(--bp-surface)' stroke='var(--bp-accent)' strokeWidth='1' />
      <text x='204' y='65' textAnchor='middle' fontSize='9' fill='var(--bp-ink2)'>概念モデル</text>
      <rect x='244' y='42' width='64' height='38' rx='3' fill='var(--bp-surface)' stroke='var(--bp-accent)' strokeWidth='1' />
      <text x='276' y='65' textAnchor='middle' fontSize='9' fill='var(--bp-ink2)'>要求・要件</text>
      <rect x='172' y='88' width='64' height='38' rx='3' fill='var(--bp-surface)' stroke='var(--bp-accent)' strokeWidth='1' />
      <text x='204' y='111' textAnchor='middle' fontSize='9' fill='var(--bp-ink2)'>業務フロー</text>
      <rect x='244' y='88' width='64' height='38' rx='3' fill='var(--bp-surface)' stroke='var(--bp-accent)' strokeWidth='1' />
      <text x='276' y='111' textAnchor='middle' fontSize='9' fill='var(--bp-ink2)'>権限</text>

      <path d='M324 85 H356' stroke='var(--bp-ink3)' strokeWidth='1.5' markerEnd='url(#onboarding-arrow)' />

      <rect x='360' y='51' width='108' height='68' rx='6' fill='var(--bp-surface2)' stroke='var(--bp-border)' strokeWidth='1.5' />
      <text x='414' y='81' textAnchor='middle' fontSize='11' fill='var(--bp-ink2)'>診断結果</text>
      <line x1='374' y1='95' x2='454' y2='95' stroke='var(--bp-border-s)' strokeWidth='2' />
      <line x1='374' y1='102' x2='434' y2='102' stroke='var(--bp-border-s)' strokeWidth='2' />

      <circle cx='444' cy='53' r='11' fill='var(--bp-critical)' />
      <text x='444' y='57' textAnchor='middle' fontSize='13' fontWeight='700' fill='#fff'>!</text>
    </svg>
  )
}
